// @flow

import { type UserInputValidationError } from '@tectonics/prs/validation';

const ZM_PHONE_REGEX = /^\+260 (?!260)\d{8,12}$/;

export function validateZambiaPhoneNumber(phoneNumberValue: string): ?UserInputValidationError {
  if (!phoneNumberValue || !phoneNumberValue.trim() || !parseInt(phoneNumberValue)) {
    return { id: 'empty' };
  } else if (!ZM_PHONE_REGEX.test(phoneNumberValue) || phoneNumberValue.length < 13) {
    return { id: 'invalid-pattern' };
  }
}
